// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__36WSc","errorLogs":"styles_errorLogs__33piC"};